import { ProductTier } from '../lib/company';
import { useCurrentCompany } from './use-current-company';
import { useIsBonuslyCompany } from './use-is-bonusly-company';

/**
 * Tiers where user-facing Bizy is available.
 * Extend this array as Bizy rolls out to additional plans.
 */
const BIZY_ENABLED_TIERS: ProductTier[] = [ProductTier.TierFree, ProductTier.TierAlpha];

/**
 * Hook to determine if user-facing Bizy should be enabled for the current user.
 *
 * Returns true if:
 * - The company's plan is in the set of Bizy-enabled tiers (Free / Team), OR
 * - The company is the Bonusly company (or the user has the mimic-bonusly flag)
 */
export function useIsBizyEnabled(): boolean {
	const company = useCurrentCompany();
	const isBonuslyCompany = useIsBonuslyCompany();

	const isTierEnabled = !!company?.product_tier && BIZY_ENABLED_TIERS.includes(company.product_tier);

	return isTierEnabled || isBonuslyCompany;
}
